/* CadastroBlock — bloco âncora visual para a esteira metodológica.
 * Mostra título, microtexto e badge de estado da etapa.
 */
import { STATE_META } from "@/lib/cadastroValidation";

export default function CadastroBlock({ id, step, title, subtitle, hint, children, dense = false }) {
  const meta = step ? STATE_META[step.state] : null;
  return (
    <section
      id={id}
      data-testid={`block-${id.replace("block-", "")}`}
      className="scroll-mt-28"
    >
      <div className={`card-mil ${dense ? "p-4" : "p-5"} space-y-4`}>
        <header className="flex items-start justify-between gap-3 flex-wrap">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <h3 className="font-display font-bold text-lg">{title}</h3>
              {meta && (
                <span
                  className={`text-[10px] uppercase tracking-wide font-semibold px-2 py-0.5 rounded-full border ${meta.bg} ${meta.border} ${meta.text}`}
                >
                  {meta.label}
                </span>
              )}
            </div>
            {subtitle && (
              <p className="text-[12px] text-[var(--text-muted)] mt-1 max-w-2xl">{subtitle}</p>
            )}
          </div>
        </header>
        {hint && (
          <div className="text-[12px] border-l-2 border-[var(--gold)] bg-[var(--surface-2)] pl-2.5 py-1.5 rounded-r">
            {hint}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
